require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./introduction-to-wms.json") })
        }
      }, "path---introduction-to-wms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---introduction-to-wms!./.cache/json/introduction-to-wms.json
// module id = 373
// module chunks = 231608221292675